import {buscador,url} from "./mapListener";
import savePlaces from "./Socket";
import MobileDetect from "mobile-detect";

var formData = new FormData();
formData.append("id",buscador.get("id"))
function saveSeats(evt){
    var element = evt.target;

    while(!element.classList.contains("mesa_container")){
        element = element.parentElement
    }

    var aux = element;
    element = element.querySelector(".mesa .table_number")
    element = element.textContent

    document.querySelectorAll(".mesa_container").forEach(element=>{
        element.removeEventListener('click',saveSeats)
    })

    savePlaces(element,document.getElementById("lugares").value)

    if (window.innerWidth <= 800){
        document.querySelector(".form").classList.remove("d-none");
        document.querySelector(".map-content").classList.add("d-none")
    }

    document.querySelector(".step-2 button").setAttribute("disabled","disabled")
    document.querySelector(".step-2 button").classList.add("disabled")

    document.querySelectorAll(".mesa_container").forEach(elem=>{
        elem.classList.add("full")
        elem.setAttribute("disabled","disabled")
    })

    aux.classList.remove("full")
}

async function checkIdentity(){
    var valor = document.getElementById("pwd").value
    var formData = new FormData()

    formData.append("owner",buscador.get("owner"))
    formData.append("password",valor)


    var resultado = await fetch("https://api.savethechildrenmx.org/events_api/login.php",{
        method:"post",
        body: formData
    }).then(resp=>{
        return resp.text()
    }).then(txt=>{
        console.log(txt)
        return txt;
    })

    var data =JSON.parse(resultado);
    if (data.status == 200){
        return data.table;
    }else{
        alert("Contraseña incorrecta, intentalo de nuevo")
        return -1
    }
}

export default async function verifySeats(evt=null){

    var flag = -1;
    if (buscador.get("owner") != null){
        flag  = await checkIdentity()
    }

    if (flag > 0){
        formData.append("table",flag)
    }

    if (buscador.get("owner") == null || (buscador.get("owner") != null && flag > 0)){
        fetch(url+"/getSeatsStatus",{
            method: 'POST',
            body:formData
        }).then(resp=>{
            if (resp.status===200){
                return resp.text()
            }
        }).then(txt=>{
            var results = JSON.parse(txt)
            console.log(results)

            document.querySelectorAll(".mesa_container").forEach(element=>{
                element.classList.add("full")
                element.setAttribute("disabled","disabled")
            })
            results.forEach(element=>{
                if (element.total >= Number(document.getElementById("lugares").value)){
                    var container = document.querySelector(".mesa-"+element.mesa).parentElement

                    container.classList.remove("full")
                    container.removeAttribute("disabled")
                    container.addEventListener('click',saveSeats)
                }
            })

            if (window.innerWidth <= 800){
                alert("Se mostrará el mapa de mesas disponibles, selecciona la mesa que quieras.")
                document.querySelector(".form").classList.add("d-none");
            }

        })
    }
}




// WEBPACK FOOTER //
// ./src/plugins/realTimeMapping.js